// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3tm_D","col":"CardReaderDesc_col__CA-ku","label":"CardReaderDesc_label__2KTww"};